import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { PatientsByCategoryReportListTemplate } from "themes/application/patients-by-category-report/pages";
import { PatientsByCategoryReportListViewStore } from "application/patients-by-category-report/stores";

@setCurrentView(rootStore => new PatientsByCategoryReportListViewStore(rootStore), "patientsByCategoryReportListViewStore")
@observer
class PatientsByCategoryReportList extends React.Component {
    render() {
        return <PatientsByCategoryReportListTemplate {...this.props} />;
    }
}

export default PatientsByCategoryReportList;